module.exports = __webpack_public_path__ + "static/media/misha_g.8325fb98.jpg";